/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMemo } from 'react'
import { FormattedDate, useIntl } from 'react-intl'
import SelectableRow from '../../../../client/js/components/selection/SelectableRow'
import { getMandateReference } from '../../lib/common/mandate.mjs'
import CustomerLink from '../customer/CustomerLink'
import Ref from '../Ref'
import MandateStatusBadge from './MandateStatusBadge'
import useMandateTypeOptions from './useMandateTypeOptions'
import { Button, Table } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import Amount from '../transaction/Amount'

export type MandateListItemProps = {
  item: Mandate,
  itemLink: string
}

function MandateListItem (props: MandateListItemProps) {
  const intl = useIntl()
  const { item, itemLink } = props

  const link = useMemo(() => (
    itemLink.replace(/{id}/g, String(item.id))
  ), [item.id, itemLink])

  const typeOptions = useMandateTypeOptions()
  const type = useMemo(() => (
    typeOptions.find((el) => el.value === item.type)?.label
  ), [item.type, typeOptions])

  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <MandateStatusBadge mandate={item} />
      </Table.Td>
      <Table.Td>
        <AnchorLink to={link}>
          <Ref value={getMandateReference(item)} />
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        {type}
      </Table.Td>
      <Table.Td>
        <CustomerLink customer={item.Customer} />
      </Table.Td>
      <Table.Td ta="end">
        <Amount value={item.price} inherit withCurrency />
      </Table.Td>
      <Table.Td>
        <FormattedDate value={item.startDate} />
      </Table.Td>
      <Table.Td>
        {item.endDate ? intl.formatDate(item.endDate) : null}
      </Table.Td>
      <Table.Td ta="end">
        <Button
          disabled={item.MandateFiles?.length === 0}
          to={`/api/mandates/${item.id}/file`}
          rel="noopener"
          size="xs"
          component={AnchorLink}
          target="_blank"
        >
          <FontAwesomeIcon icon={faDownload} />
        </Button>
      </Table.Td>
    </SelectableRow>
  )
}

export default MandateListItem
